import { Link } from "react-router-dom";
import bgImg from "../../../assets/image/visa-bg.png";

import Hotobad1 from "../../../assets/image/hotobad1.png";
import Hotobad2 from "../../../assets/image/hotobad2.png";
import Hotobad3 from "../../../assets/image/hotobad3.png";
import Hotobad4 from "../../../assets/image/hotobad4.png";
import Hotobad5 from "../../../assets/image/hotobad5.png";

export default function ApplyQuickVisa() {
  const countries = [
    { title: "Montreal", image: Hotobad1 },
    { title: "Brampton", image: Hotobad2 },
    { title: "Ottawa", image: Hotobad3 },
    { title: "Surrey", image: Hotobad4 },
    { title: "Calgary", image: Hotobad5 },
  ];

  return (
    <section
      className="relative py-12 md:py-24"
      style={{
        backgroundImage: `url(${bgImg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 text-center text-white">
        <p className="text-sm uppercase tracking-widest font-semibold mb-3">
          Provinces We Support
        </p>

        <h2 className="text-3xl md:text-5xl font-bold mb-6">
          Apply for Your File Today
        </h2>

        <div className="flex justify-center gap-2 mb-10">
          <span className="w-12 h-[3px] bg-[#ec4e4f]"></span>
          <span className="w-1 h-[3px] bg-[#ec4e4f]"></span>
          <span className="w-1 h-[3px] bg-[#ec4e4f]"></span>
          <span className="w-1 h-[3px] bg-[#ec4e4f]"></span>
        </div>

        {/* RESPONSIVE GRID */}
        <div
          className="
            grid 
            grid-cols-1 
            sm:grid-cols-2 
            md:grid-cols-3 
            lg:grid-cols-5
            gap-6
          "
        >
          {countries.map((item, index) => (
            <Link key={index} to="/contact-us">
              <div className="group relative overflow-hidden rounded-lg">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-[200px] object-cover transition-transform duration-500 group-hover:scale-110"
                />

                <div className="absolute inset-0 bg-black/50"></div>

                <div className="absolute inset-0 flex items-center justify-center">
                  <h3 className="text-white text-xl md:text-2xl font-semibold tracking-wide">
                    {item.title}
                  </h3>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
